import React, {useEffect, useState} from 'react';
import {Link, useParams} from "react-router-dom";
import {Breadcrumb, Container, Card, Form, Row, Col, Table, Button} from "react-bootstrap";
import {validationSchema} from "../../../../EmployeeManagement/EmployeeEdit/Retail/Company/validationSchema";
import { Formik, FieldArray} from 'formik';
import axios from "../../../../../api";
import {IAPI_Response} from "../../../../../api/types";
import {IItem} from "../../../../EmployeeManagement/EmployeeEdit/Retail/types";
import {API_ENDPOINT, ERROR_MESSAGE, SUCCESS_MESSAGE} from "../../../../../utils/globalConstant";
import {ICondition, IConfiguration} from "./types";
import Alert from "components/Alert";
import EditIcon from "asset/SvgComponent/EditIcon";
import AddEmployee from "asset/SvgComponent/AddEmployee";
import CircleCreate from "asset/SvgComponent/CircleCreate";
import Write from "asset/SvgComponent/Write";
import Delete from "asset/SvgComponent/Delete"

function ConfigurationEdit() {
    const {id} = useParams();
    const [error, setError] = useState('')
    const [showError, setShowError] = useState(false)
    const [success, setSuccess] = React.useState('')
    const [showSuccess, setShowSuccess] = React.useState(false)
    const [apiData, setApiData] = useState<IConfiguration>();
    const initValues: IConfiguration = {
        type: "",
        name: "",
        condition_type: "",
        capture_screenshot: 0,
        is_multiple_screenshots: 0,
        screenshot_every_second: 0,
        display_message: 0,
        message: "",
        send_email: 0,
        email_to: "",
        email_subject: "",
        email_body: "",
        is_active: 0,
        conditions: []
    }

    const handleAddCondition = () => {
        const newCondition = {
            id: Math.floor((Math.random() * 1000) + Date.now() % 1000),
            field: 'Url',
            operator: 'Starts With',
            value: '',
            is_case_sensitive: 0,
            is_new: 1,
            alarm_configuration_id: id
        };

        setApiData((prevValues: any) => {
            if (!prevValues) return prevValues; // Early return if undefined

            return {
                ...prevValues,
                conditions: [...(prevValues.conditions ?? []), newCondition], // handle undefined conditions
            };
        });
    }

    const handleEditCondition = (id: any) => {
        setApiData((prevValues: any) => {
            if (!prevValues) return prevValues; // Early return if undefined

            const updatedConditions = prevValues.conditions.map((cond: any, i: number) =>
                cond.id === id ? { ...cond, is_new: 1 } : cond
            );

            return {
                ...prevValues,
                conditions: updatedConditions,
            };
        });
    }

    const handleDeleteCondition = (id: any) => {
        setApiData(prevValues => {
            if (!prevValues || !prevValues.conditions) return prevValues;

            const updatedConditions = prevValues.conditions.filter(
                condition => condition.id !== id
            );

            return {
                ...prevValues,
                conditions: updatedConditions,
            };
        });
    }

    const getConfigurationByID = async () => {
        try {
            const response = await axios.get<IAPI_Response<IConfiguration>>(API_ENDPOINT.GET_ALARM_CONFIGURATION_BY_ID + '/' + id)
            console.log(response)
            setApiData(response.data.results)

        }catch {
            setShowError(true)
            setError(ERROR_MESSAGE.SYSTEM_ERROR)
        }
    }

    const obSubmit = async(value: any) => {
        await axios.put(API_ENDPOINT.PUT_ALARM_CONFIGURATION, {
            id: id,
            type: value.type,
            name: value.name,
            condition_type: value.condition_type,
            capture_screenshot: value.capture_screenshot,
            is_multiple_screenshots: value.is_multiple_screenshots,
            screenshot_every_second: value.screenshot_every_second,
            display_message: value.display_message,
            message: value.message,
            send_email: value.send_email,
            email_to: value.email_to,
            email_subject: value.email_subject,
            email_body: value.email_body,
            is_active: value.is_active,
            conditions: value.conditions
        }).then(response => {
            if (response?.data?.status * 1 === 1) {

                setShowSuccess(true)
                setSuccess(SUCCESS_MESSAGE.ALARM_CONFIGURATION.UPDATED)
            }else{
                setShowError(true)
                setError("Error. Please check lacking fields.")
            }
        }).catch(error => {
            setShowError(true)
            setError("Error. Please check lacking fields.")
        })

        setTimeout(() => {
            setShowSuccess(false)
            setShowError(false)
        }, 3000);
    }

    useEffect(() => {
        ;(async () => {
            getConfigurationByID()
        })()
    }, [])

    return (
        <>
            <Container fluid>
                <h5 className='fw-bold'>Alarm Configuration</h5>
                <Breadcrumb className='breadcrumbs'>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Home
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Monitoring
                    </Breadcrumb.Item>
                    <Breadcrumb.Item className=' text-decoration-none' href='#'>
                        Alarms
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active>Alarm Configuration</Breadcrumb.Item>
                </Breadcrumb>

                <Card className='border-0  p-0 bordered-card mb-4'>
                    <Card.Body>
                        <Formik
                            initialValues={apiData || initValues}
                            enableReinitialize
                            // validationSchema={validationSchema}
                            onSubmit={obSubmit}
                        >
                            {({
                                  values,
                                  errors,
                                  touched,
                                  handleChange,
                                  handleBlur,
                                  handleSubmit,
                                  isSubmitting
                              }) => (

                                <Form noValidate onSubmit={handleSubmit}>
                                    <Row className="mb-3">
                                        <span className='fw-bold'>Alarm Configuration</span>
                                    </Row>

                                    <Row className="mb-2">
                                        <Form.Group as={Col} md="2">
                                            <Form.Label column="sm" >Type</Form.Label>
                                        </Form.Group>
                                        <Form.Group as={Col} md="4" className="position-relative">
                                            <Form.Select
                                                size={'sm'}
                                                name="type"
                                                value={values.type}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.type && !!errors.type}
                                            >
                                                <option value="">Select Type</option>
                                                <option value="activity">Activity</option>
                                                <option value="security">Security</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid" tooltip>
                                                {errors.type}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} md="2">
                                            <Form.Label column="sm" >Status</Form.Label>
                                        </Form.Group>
                                        <Form.Group as={Col} md="4" className="position-relative">
                                            <Form.Select
                                                size={'sm'}
                                                name="is_active"
                                                value={values.is_active}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.is_active && !!errors.is_active}
                                            >
                                                <option value="1">Active</option>
                                                <option value="0">Inactive</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid" tooltip>
                                                {errors.is_active}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Row>
                                    <Row className="mb-2">
                                        <Form.Group as={Col} md="2" >
                                            <Form.Label column="sm">Name</Form.Label>
                                        </Form.Group>
                                        <Form.Group as={Col} md="4" className="position-relative">
                                            <Form.Control
                                                size={'sm'}
                                                type='text'
                                                placeholder='Name'
                                                name="name"
                                                value={values.name}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={(touched.name && !!errors.name)}
                                            />

                                            <Form.Control.Feedback type="invalid" tooltip>
                                                {errors.name}
                                            </Form.Control.Feedback>

                                        </Form.Group>
                                    </Row>
                                    <hr className='mb-4'/>
                                    <Row className='mb-4'>
                                        <span className='text-center fw-bold'>Alarm Conditions</span>
                                    </Row>
                                    <Row className='mb-1'>
                                        <Form.Group as={Col} md="2">
                                            <Form.Label column="sm">Match Condition</Form.Label>
                                        </Form.Group>
                                        <Form.Group as={Col} md="2" className="position-relative">
                                            <Form.Select
                                                size={'sm'}
                                                name="condition_type"
                                                value={values.condition_type}
                                                onChange={handleChange}
                                                onBlur={handleBlur}
                                                isInvalid={touched.condition_type && !!errors.condition_type}
                                            >
                                                <option value="0">Match Any</option>
                                                <option value="1">Match All</option>
                                            </Form.Select>
                                            <Form.Control.Feedback type="invalid" tooltip>
                                                {errors.condition_type}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                    </Row>
                                    <Row>
                                        <Table className='bordered-tabs-top mt-2' responsive>
                                            <thead>
                                                <tr>
                                                    <th style={{width: '25%'}} className={'text-center'}>Field</th>
                                                    <th style={{width: '25%'}} className={'text-center'}>Operator</th>
                                                    <th style={{width: '25%'}} className={'text-center'}>Value</th>
                                                    <th style={{width: '10%'}} className={'text-center'}>Case Sensitive</th>
                                                    <th style={{width: '15%'}} className={'text-center'}>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    values.conditions.map((condition, index) => (
                                                        <tr key={index}>
                                                            {
                                                                condition.is_new == 0 ?
                                                                    <>
                                                                        <td className={'text-center'}>{condition.field}</td>
                                                                        <td className={'text-center'}>{condition.operator}</td>
                                                                        <td className={'text-center'}>{condition.value}</td>
                                                                        <td className={'text-center'}>{condition.is_case_sensitive == 1 ? "Yes" : "No"}</td>
                                                                        <td className={'text-center'}>
                                                                            <Button
                                                                                className=' p-1 pt-0 pb-0'
                                                                                style={{ fontSize: '12px', color: 'white' }}
                                                                                variant=' btn-transparent'
                                                                                size='sm'
                                                                                onClick={() => handleEditCondition(condition.id)}
                                                                            >
                                                                                <Write/>
                                                                            </Button>
                                                                            <Button
                                                                                className=' p-1 pt-0 pb-0'
                                                                                style={{ fontSize: '12px', color: 'white' }}
                                                                                variant=' btn-transparent'
                                                                                size='sm'
                                                                                onClick={() => handleDeleteCondition(condition.id)}
                                                                            >
                                                                                <Delete/>
                                                                            </Button>
                                                                        </td>
                                                                    </>

                                                                : <>
                                                                        <td className={'text-center'}>
                                                                            <Form.Group className="position-relative w-80">
                                                                                <Form.Select
                                                                                    size={'sm'}
                                                                                    name={`conditions[${index}].field`}
                                                                                    value={condition.field}
                                                                                    onChange={handleChange}
                                                                                >
                                                                                    <option className={'text-center'} value="Url">Url</option>
                                                                                </Form.Select>

                                                                            </Form.Group>
                                                                        </td>
                                                                        <td>
                                                                            <Form.Group className="position-relative w-80">
                                                                                <Form.Select
                                                                                    size={'sm'}
                                                                                    name={`conditions[${index}].operator`}
                                                                                    value={condition.operator}
                                                                                    onChange={handleChange}
                                                                                >
                                                                                    <option className={'text-center'} value="Starts With">Starts With</option>
                                                                                    <option className={'text-center'} value="Contains">Contains</option>
                                                                                </Form.Select>

                                                                            </Form.Group>
                                                                        </td>
                                                                        <td>
                                                                            <Form.Group className="position-relative w-80">
                                                                                <Form.Control
                                                                                    size={'sm'}
                                                                                    type='text'
                                                                                    placeholder='Value'
                                                                                    name={`conditions[${index}].value`}
                                                                                    value={condition.value}
                                                                                    onChange={handleChange}
                                                                                />

                                                                            </Form.Group>
                                                                        </td>
                                                                        <td>
                                                                            <Form.Group className="position-relative w-80">
                                                                                <Form.Select
                                                                                    size={'sm'}
                                                                                    name={`conditions[${index}].is_case_sensitive`}
                                                                                    value={condition.is_case_sensitive}
                                                                                    onChange={handleChange}
                                                                                >
                                                                                    <option className={'text-center'} value="1">Yes</option>
                                                                                    <option className={'text-center'} value="0">No</option>
                                                                                </Form.Select>

                                                                            </Form.Group>
                                                                        </td>
                                                                        <td className={'text-center'}>
                                                                            <Button
                                                                                className=' p-1 pt-0 pb-0'
                                                                                style={{ fontSize: '12px', color: 'white' }}
                                                                                variant=' btn-transparent'
                                                                                size='sm'
                                                                                onClick={() => handleEditCondition(condition.id)}
                                                                            >
                                                                                <Write/>
                                                                            </Button>
                                                                            <Button
                                                                                className=' p-1 pt-0 pb-0'
                                                                                style={{ fontSize: '12px', color: 'white' }}
                                                                                variant=' btn-transparent'
                                                                                size='sm'
                                                                                onClick={() => handleDeleteCondition(condition.id)}
                                                                            >
                                                                                <Delete/>
                                                                            </Button>
                                                                        </td>
                                                                    </>
                                                            }

                                                        </tr>
                                                    ))
                                                }
                                                <tr>
                                                    <td colSpan={5} className={'text-center'}>
                                                        <Button
                                                        className=' add-new-btn rounded mx-2'
                                                        variant='transparent'
                                                        title={"Add New Condition"}
                                                        onClick={handleAddCondition}
                                                    >
                                                        <CircleCreate/><span className="d-none d-md-inline"> &nbsp; Add New Condition</span>
                                                        </Button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </Table>
                                    </Row>
                                    <hr className='mb-4'/>
                                    <Row>
                                        <Col sm={6}>
                                            <Row className='mb-4'>
                                                <span className='text-center fw-bold'>Capture Screenshot</span>
                                            </Row>
                                            <Row className='mb-2'>
                                                <Form.Group as={Col} md="12" className="position-relative">
                                                    <Form.Check
                                                        type="switch"
                                                        id="custom-switch"
                                                        name={'capture_screenshot'}
                                                        label="Capture screenshots when the alarm is triggered"
                                                        checked={values.capture_screenshot == 1? true:false}
                                                        // value={values.capture_screenshot}
                                                        onChange={(e) => {
                                                            const isChecked = e.target.checked;
                                                            // Manually set the field value to 1 or 0
                                                            handleChange({
                                                                target: {
                                                                    name: 'capture_screenshot',
                                                                    value: isChecked ? 1 : 0
                                                                }
                                                            });
                                                        }}
                                                        onBlur={handleBlur}
                                                        isInvalid={(touched.capture_screenshot && !!errors.capture_screenshot)}
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Row className='mb-2'>
                                                <Form.Group as={Col} md="12" className="position-relative">
                                                    <Form.Check
                                                        inline
                                                        label="Single Screenshot"
                                                        name="is_multiple_screenshots"
                                                        value="0"
                                                        type="radio"
                                                        id="inline-radio-0"
                                                        checked={values.is_multiple_screenshots == 0}
                                                        onChange={handleChange}
                                                        isInvalid={touched.is_multiple_screenshots && !!errors.is_multiple_screenshots}
                                                    />
                                                    <Form.Check
                                                        inline
                                                        label="Multiple Screenshots"
                                                        name="is_multiple_screenshots"
                                                        value="1"
                                                        type="radio"
                                                        id="inline-radio-1"
                                                        checked={values.is_multiple_screenshots == 1}
                                                        onChange={handleChange}
                                                        isInvalid={touched.is_multiple_screenshots && !!errors.is_multiple_screenshots}
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-2 align-items-center">
                                                <span className="col-auto">Every</span>
                                                <Form.Group as={Col} md="4" className="position-relative">
                                                    <Form.Control
                                                        size="sm"
                                                        type="number"
                                                        name="screenshot_every_second"
                                                        value={values.screenshot_every_second}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        isInvalid={touched.screenshot_every_second && !!errors.screenshot_every_second}
                                                        disabled={values.is_multiple_screenshots != 1 || values.capture_screenshot != 1}
                                                    />
                                                    <Form.Control.Feedback type="invalid" tooltip>
                                                        {errors.screenshot_every_second}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                                <span className="col-auto">seconds</span>
                                            </Row>
                                        </Col>

                                        <Col sm={6}>
                                            <Row className='mb-4'>
                                                <span className='text-center fw-bold'>Email Notification</span>
                                            </Row>
                                            <Row className='mb-2'>
                                                <Form.Group as={Col} md="12" className="position-relative">
                                                    <Form.Check
                                                        type="switch"
                                                        id="custom-switch"
                                                        name={'send_email'}
                                                        label="Send email notification when the alarm is triggered"
                                                        checked={values.send_email == 1? true:false}
                                                        onChange={(e) => {
                                                            const isChecked = e.target.checked;
                                                            // Manually set the field value to 1 or 0
                                                            handleChange({
                                                                target: {
                                                                    name: 'send_email',
                                                                    value: isChecked ? 1 : 0
                                                                }
                                                            });
                                                        }}
                                                        onBlur={handleBlur}
                                                        isInvalid={(touched.send_email && !!errors.send_email)}
                                                    />
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-2 align-items-center">
                                                <Form.Group as={Col} md="4">
                                                    <Form.Label column="sm">Email To</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Col} md="8" className="position-relative">
                                                    <Form.Control
                                                        size="sm"
                                                        type="text"
                                                        name="message"
                                                        value={values.message}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        isInvalid={touched.message && !!errors.message}
                                                        disabled={values.send_email != 1}
                                                    />
                                                    <Form.Control.Feedback type="invalid" tooltip>
                                                        {errors.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-2 align-items-center">
                                                <Form.Group as={Col} md="4" >
                                                    <Form.Label column="sm">Email Subject</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Col} md="8" className="position-relative">
                                                    <Form.Control
                                                        size="sm"
                                                        type="text"
                                                        name="message"
                                                        value={values.message}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        isInvalid={touched.message && !!errors.message}
                                                        disabled={values.send_email != 1}
                                                    />
                                                    <Form.Control.Feedback type="invalid" tooltip>
                                                        {errors.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>
                                            <Row className="mb-2 align-items-center">
                                                <Form.Group as={Col} md="4">
                                                    <Form.Label column="sm">Email Body</Form.Label>
                                                </Form.Group>
                                                <Form.Group as={Col} md="8" className="position-relative">
                                                    <Form.Control
                                                        size="sm"
                                                        as="textarea"
                                                        rows={3}
                                                        name="message"
                                                        value={values.message}
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        isInvalid={touched.message && !!errors.message}
                                                        disabled={values.send_email != 1}
                                                    />
                                                    <Form.Control.Feedback type="invalid" tooltip>
                                                        {errors.message}
                                                    </Form.Control.Feedback>
                                                </Form.Group>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <Row className="mt-5 text-right">
                                        <Form.Group as={Col} md="6">
                                            <Button
                                                type="submit"
                                                disabled={isSubmitting}
                                                variant='primary text-white'
                                                style={{ width: '25%' }}
                                                size="sm">
                                                Save
                                            </Button>
                                        </Form.Group>
                                    </Row>

                                </Form>
                            )}
                        </Formik>

                    </Card.Body>
                </Card>

                <Alert
                    type="success"
                    show={showSuccess}
                    message={success}
                    setShow={() => {
                        setShowSuccess(false);
                    }
                    }
                />
                <Alert
                    type="error"
                    show={showError}
                    message={error}
                    setShow={() => {
                        setShowError(false);
                    }
                    }
                />
            </Container>
        </>
    )
}

export default ConfigurationEdit;